module.exports = { id: "front-motor", url: "/build/app/img/symbols.svg#front-motor", viewBox: "", toString: function() { return this.url; } };